import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestApproveReturn } from "./approveReturn.request";

const useApproveReturn = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestApproveReturn,
    ...options
  });
};

export default useApproveReturn;
